import React, { useState, useRef, useCallback } from "react"
import {
  Row,
  Col
} from "reactstrap";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment';

const InvoiceFilter = (props) => {
  const { query, setQuery } = props
  const [paidDate, setPaidDate] = useState(null);
  const formRef = useRef(null);

  const userNameChange = (value) => {
    if (value.keyCode === 13)
      setQuery({
        ...query,
        user_name: value.target.value,
      });
  };

  const amountChange = (value) => {
    if (value.keyCode === 13)
      setQuery({
        ...query,
        amount: value.target.value,
      });
  };

  const remove = useCallback((key) => {
    setQuery(({ [key]: value, ...query }) => query);
  }, []);

  const handlePaidDate = (date) => {
    if (date) {
      setPaidDate(date);
      setQuery({
        ...query,
        paid_date: moment(date).format("MMM DD, YYYY"),
      });
    } else {
      remove('paid_date')
      setPaidDate(date);
    }
  };

  const clearFilters = () => {
    setPaidDate(null);
    setQuery({});
    formRef.current.reset();
  };

  return (
    
    <div className="card candidate-filters  border border-primary">
      <div className="card-header">
        <h5 className="card-title">Invoices Filters</h5>
      </div>
      <form ref={formRef} className=" card-body pb-0 ">
        <Row>
          <Col lg={10}>
            <Row>
              <Col lg={4}>
                <div className="form-group">
                  <input
                    name="user-name"
                    placeholder="User Name"
                    className="form-control"
                    onChange={(e) => userNameChange(e)}
                    type="text"
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group">
                  <input
                    name="amount"
                    placeholder="Amount"
                    className="form-control"
                    onChange={(e) => amountChange(e)}
                    type="text"
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      autoOk
                      clearable
                      format="yyyy-MM-dd"
                      className="form-control"
                      placeholder="Payment Date"
                      value={paidDate}
                      onChange={(e) =>handlePaidDate(e)
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={2}>
            <Row className="mb-3">
              <Col lg={12}>
                <div className="form-group">
                  <button type="button" className="btn btn-secondary btn-block" onClick={() => clearFilters()}>
                    Clear Filters
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
    </div>
  )
}

export default (connect(null, null)(InvoiceFilter));
